<template>

<ul v-if="result.length>0" id="queens">
    <li v-for="queen in result" :key="queen.id" class="card" v-bind:id="'colmenar'+queen.id">
        <div class="info-item">
            <div class="info-item-list-left">

                <a v-bind:href="'#/queen-detalle/' + queen.id">
                    <p class="title-box">
                        <span v-bind:class="'badge badge-'+queen.color">{{ queen.year }}</span>
                        {{ queen.name }}</p>

                    <infoqueen
                            v-bind:description="queen.description"
                    ></infoqueen>

                    <p v-if="queen.color==='sin marcar'" class="text-red">Sin marcar</p>

                    <lastcyclequeen v-bind:idqueen="queen.id"
                                    v-bind:colmena="queen.number"
                                    v-bind:colmenar="queen.namecolmenar"
                                    v-bind:date="queen.date"
                                    v-bind:cycle="queen.cycle"
                                    v-bind:state="queen.state"
                                    v-bind:color="queen.color"
                                    v-bind:date_archived="queen.date_archived"
                    ></lastcyclequeen>

                </a>
            </div>

            <div class="info-item-list-right">

                <a v-bind:href="'#/queen-detalle/' + queen.id">
                    <v-icon color="grey">mdi-chevron-right</v-icon>
                </a>
            </div>
        </div>
    </li>
</ul>

<div v-else class="card">
    <div style="padding:20px; text-align:center">
        No hay reinas.
    </div>
    <router-link to="../queen-nueva" class="btn btn-yellow">
        Añadir reina
    </router-link>
</div>

</template>

<script>

import lastcyclequeen from "@/components/queens/lastcyclequeen"
import infoqueen from "@/components/queens/infoqueen"

export default {
  name: 'listar-reinas',
  props: ['result'],
  components: {lastcyclequeen,infoqueen},
};
</script>